module.exports = __webpack_public_path__ + "static/media/Charles J. Jenkins - 1872.05d9ed18.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/us/Charles J. Jenkins - 1872.jpg
// module id = 451
// module chunks = 0